import {
  FormValidator,
  type FormValidatorConfig,
  type FormValidatorContext,
  type FormValidatorSettings,
  isEmpty,
  setApiValidationErrorMessages
} from '@common';
import { useSharedApi } from '../../../api/shared.api';

export type PhoneNumberValidatorSettings = FormValidatorSettings;
export type PhoneNumberValidatorConfig = FormValidatorConfig<PhoneNumberValidatorSettings>;

export class PhoneNumberValidator extends FormValidator<PhoneNumberValidatorSettings> {
  validatorApiService = useSharedApi().validator;

  constructor() {
    super();
    this._name = 'phoneNumber';
    this._settings = {
      invalidMessage: 'form.validator.phoneNumber.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    if (isEmpty(value) || !context.element.enabled) {
      return;
    }

    this._valid = true;

    try {
      await this.validatorApiService.getValidatePhoneNumber(value);
    } catch (error: any) {
      setApiValidationErrorMessages(error.data.data, this);
      this._valid = false;
    }
  }
}
